import { Box, Text } from '@chakra-ui/react';

const ReactionDisplay = ({
  latestReactionUser,
  likesCount,
  onClickReactionUsers,
}) => {
  return (
    <Box className="flex items-center gap-1 mb-2">
      {latestReactionUser && likesCount > 0 && (
        <Text
          fontSize="sm"
          color="gray.600"
          cursor="pointer"
          className="hover:underline hover:text-blue-600"
          onClick={(e) => {
            e.stopPropagation();
            onClickReactionUsers();
          }}
        >
          <Text as="span" fontWeight="medium">
            {latestReactionUser.first_name} {latestReactionUser.last_name}
          </Text>
          {likesCount > 1 && <> and {likesCount - 1} others</>}
          {likesCount === 1 && <> reacted to this</>}
        </Text>
      )}
    </Box>
  );
};

export default ReactionDisplay;
